'use client'

import { useTheme } from 'next-themes'
import { Toaster as Sonner } from 'sonner'

type ToasterProps = React.ComponentProps<typeof Sonner>

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = 'system' } = useTheme()

  return (
    <Sonner
      theme={theme as ToasterProps['theme']}
      className="toaster group"
      position="bottom-left"
      toastOptions={{
        classNames: {
          toast:
            'bg-gradient-to-br from-[#2F1E30]/95 via-[#3D2A3E] to-[#2F1E30]/95 backdrop-blur-lg border border-white/10 text-white shadow-lg rounded-xl px-4 py-3 min-w-[320px] max-w-[400px] text-sm',
          description: 'text-white/80 text-sm mt-1',
          title: 'text-white font-medium text-base',
          actionButton:
            'bg-white/10 text-white hover:bg-white/20 rounded-lg px-3 py-1.5 text-sm font-medium transition-colors',
          cancelButton:
            'bg-white/10 text-white hover:bg-white/20 rounded-lg px-3 py-1.5 text-sm transition-colors',
          error:
            'bg-gradient-to-br from-red-600/95 via-red-500/95 to-red-600/95 border-red-400/30',
          success:
            'bg-gradient-to-br from-green-600/95 via-green-500/95 to-green-600/95 border-green-400/30',
          info: 'bg-gradient-to-br from-blue-600/95 via-blue-500/95 to-blue-600/95 border-blue-400/30',
          warning:
            'bg-gradient-to-br from-yellow-600/95 via-yellow-500/95 to-yellow-600/95 border-yellow-400/30',
          closeButton:
            'text-white/80 hover:text-white hover:bg-white/10 rounded-md transition-colors',
        },
      }}
      {...props}
    />
  )
}

export { Toaster }
